/** WebNIC-specific part of a connection page: the IP allow-list note. */

import { useTranslation } from 'react-i18next';
import { Callout } from '../../../components/blocks';

/** WebNIC answers only calls from addresses on the account's IP allow-list. */
export function WebnicAllowListNote({ className, compact = false }: { className?: string; compact?: boolean }) {
  const { t } = useTranslation('integrations');
  return (
    <Callout tone="info" title={compact ? undefined : t('webnic.allowListTitle')} className={className}>
      <p>{t('webnic.allowList')}</p>
      {compact ? null : <p className="mt-1">{t('webnic.allowListHow')}</p>}
    </Callout>
  );
}
